import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueryImageByUrlPipe } from './query-image-by-url.pipe';
import { QueryPortNamePipe } from './query-port-name.pipe';



@NgModule({
  declarations: [
    QueryImageByUrlPipe,
    QueryPortNamePipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    QueryImageByUrlPipe,
    QueryPortNamePipe
  ]
})
export class QueryPipesModule { }
